<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Inspection Intervals & Dates</h2>
    </div>
    <br />


    <div class="row content-block">
      <div class="col">
        <table class='table table-bordered table-hover' >
          <thead class='thead-light'>
            <tr>
              <th>Name</th>
              <th>Value</th>
              <th>Unit</th>
              <th>Calendar Colour</th>
            </tr>
          </thead>
          <tbody>
            @for (interval of this.intervals; track interval) {
              <tr>
                <td>{{interval.name}}</td>
                <td>{{interval.number}}</td>
                <td>{{interval.unit}}</td>
                <td>
                  <div style='width:100%;height:20px;border:1px solid black;' [style.background-color]='interval.colour'></div>
                </td>
              </tr>
            }
            @if (!addRow) {
              <tr>
                <td colspan='4'>
                  <button class='btn btn-secondary' (click)='addNewRow()'><i class="fas fa-plus"></i> New</button>
                </td>
              </tr>
            }

            @if (addRow) {
              <tr>
                <td>
                  <label>Name</label>
                  <input type='text' [(ngModel)]='this.newRow.name' class='form-control' [class.is-valid]='this.newRow.name !== ""' [class.is-invalid]='this.newRow.name === ""'/>
                </td>
                <td>
                  <label>Value</label>
                  <input type='text' [(ngModel)]='this.newRow.number' class='form-control' [class.is-valid]='this.newRow.name >= 0' [class.is-invalid]='this.newRow.name < 0'/>
                </td>
                <td>
                  <label>Time Unit</label>
                  <select
                    (change)='this.newRow.unit = $event.target.value;'
                    class='form-control'
                    >
                    @for (item of this.timeUnits; track item) {
                      <option
                        [value]='item.name'
                        [selected]='this.newRow.unit === item.name'>
                        {{ item.name }}
                      </option>
                    }
                  </select>
                </td>
                <td>
                  <label>Colour Tag</label>
                  <input type='color' [(ngModel)]='this.newRow.colour' placeholder='#FFFFFF' class='form-control'/>
                </td>
              </tr>
              <tr>
                <td colspan='4'><button class='btn btn-success' (click)='saveRow()'>Save</button></td>
              </tr>
            }

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
